
<template>
  <div class="assumptions">

    <div class="assumption-selector">
      <div>
        <v-icon
          class="pt-1 pb-1"
          medium
          :color="freightSelectorColor"
          @click="currentView = 'freight'"
        >
          local_shipping
        </v-icon>
        <!--<v-icon
          class="pt-1 pb-1"
          medium
          :color="inventorySelectorColor"
          @click="currentView = 'inventory'"
        >
          dashboard
        </v-icon>-->
        <v-icon
          class="pt-1 pb-1"
          medium
          :color="laborSelectorColor"
          @click="currentView = 'labor'"
        >
          person
        </v-icon>
        <v-icon
          class="pt-1 pb-1"
          medium
          :color="leaseSelectorColor"
          @click="currentView = 'lease'"
        >
          business
        </v-icon>
      </div>
    </div>

    <div class="assumption-container">
      <freight-assumptions v-show="currentView == 'freight'" ref="freightAssumptions"></freight-assumptions>
      <inventory-assumptions v-show="currentView == 'inventory'" ref="inventoryAssumptions"></inventory-assumptions>
      <labor-assumptions v-show="currentView == 'labor'" ref="laborAssumptions"></labor-assumptions>
      <lease-assumptions v-show="currentView == 'lease'" ref="leaseAssumptions"></lease-assumptions>
    </div>

    <div class="adjust-actions">
      <a @click="resetAssumptionValues" class="pl-1">Reset </a>
      <span style="color: #aaa">|</span>
      
      <a @click="applySelected()" class="pl-1 pr-1">OK</a>
    </div>

  </div>
</template>

<script>
export default {
  name: 'assumptions-adjuster',
  data () {
    return {
      currentView: "freight"
    }
  },

  methods: {
    applySelected() {
      this.$emit("did-apply")
    },
    selectorColor(isSelected) {
      return isSelected ? "blue darken-3" : "grey"
    },
    resetAssumptionValues() {
      if(this.currentView == "freight") {
        this.$refs.freightAssumptions.resetAssumptionValues()
      } else if(this.currentView == "inventory") {
        this.$refs.inventoryAssumptions.resetAssumptionValues()
      } else if(this.currentView == "labor") {
        this.$refs.laborAssumptions.resetAssumptionValues()
      } else if(this.currentView == "lease") {
        this.$refs.leaseAssumptions.resetAssumptionValues()
      }
    }
  },

  computed: {
    freightSelectorColor() {
      return this.selectorColor(this.currentView == 'freight')
    },
    inventorySelectorColor() {
      return this.selectorColor(this.currentView == 'inventory')
    },
    laborSelectorColor() {
      return this.selectorColor(this.currentView == 'labor')
    },
    leaseSelectorColor() {
      return this.selectorColor(this.currentView == 'lease')
    }

  },

  components: {
    'freight-assumptions': () => import ('@/components/FreightAssumptions'),
    'inventory-assumptions': () => import ('@/components/InventoryAssumptions'),
    'labor-assumptions': () => import ('@/components/LaborAssumptions'),
    'lease-assumptions': () => import ('@/components/LeaseAssumptions'),
  }
}

</script>


<style scoped>
a:hover {
  font-weight: bold;
}

.assumptions {
  background-color: #FFF0E8;
  height: 100%;
}
.assumption-selector {
  position: absolute;
  top: 0px;
  left: 8px;
  width: 35px;
  height: 100%;
  padding-top: 9px;
  border-right: 1px solid #ccc;
}
.assumption-container {
  height: 100%;
  position: absolute;
  left: 45px;
  width: calc(100% - 210px);
}
.adjust-actions {
  display: inline-block;
  font-size: 10pt;
  position: absolute;
  right: 180px;
  top: 5px;
}
.section-title {
  text-align: left;
  padding-left: 10px;
  color: #444;
}
.adjust-section-title {
  font-weight: bold;
  font-size: 13pt;
}



@media only screen and (max-width: 600px) {
  .adjust-actions {
    right: 5px;
  }
  .assumption-container {
    width: calc(100% - 50px);
  }

}

@media only screen and (max-height: 550px) {
  .adjust-actions {
    right: 5px;
  }
  .assumption-container {
    width: calc(100% - 50px);
  }
}

</style>